module.exports = __webpack_public_path__ + "img/lun1.5d88e08e.webp";